import styles from './style.postcss';

import React from 'react';
import { PaperbasedHomeworkStatus } from 'data/PaperBasedHomework/status';
import is from 'is_js';
import { Icon } from 'omni-common-ui';
import classnames from 'classnames';
import PropTypes from 'prop-types';

const PaperFolding = ({ paperBasedStatus }) => {
  return <div className={styles.PaperBasedBall}>
    {renderStatus()}
  </div>;

  function renderStatus() {
    if (paperBasedStatus === PaperbasedHomeworkStatus.notapplicable) {
      return 'n/a';
    }

    if (is.not.string(paperBasedStatus)) {
      return '–';
    }

    const imgConf = getImgConf();
    return <Icon id={imgConf.src}
        className={classnames(styles.PaperBasedBall_img, imgConf.class)}
        title={imgConf.alt} />;
  }

  function getImgConf() {
    switch (paperBasedStatus) {
      case PaperbasedHomeworkStatus.complete:
        return { src: 'success', alt: PaperbasedHomeworkStatus.complete, class: styles.__complete };
      case PaperbasedHomeworkStatus.incomplete:
        return { src: 'cross-circle', alt: PaperbasedHomeworkStatus.incomplete, class: styles.__incomplete };
      case PaperbasedHomeworkStatus.unmarked:
        return { src: 'circle', alt: PaperbasedHomeworkStatus.unmarked, class: styles.__unmarked };
      case PaperbasedHomeworkStatus.partialcomplete:
        return { src: 'success', alt: 'Partial Complete', class: styles.__partialComplete };
      default:
        throw new Error(`Invalid paper based homework status: ${paperBasedStatus}`);
    }
  }
};

PaperFolding.propTypes = {
  paperBasedStatus: PropTypes.oneOf(Object.keys(PaperbasedHomeworkStatus)),
};

export default PaperFolding;



// WEBPACK FOOTER //
// ./containers/Group/Homework/PaperBased/MarkHomeworkCourseView/PaperFolding/index.jsx